import { Button } from "@/ui/button";

const SessionLost = () => {
	return (
		<div className="oidc-session-lost">
			<div className="oidc-session-lost__container">
				<h1 className="oidc-session-lost__title">Session timed out</h1>
				<p className="oidc-session-lost__content">Your session has expired. Please re-authenticate.</p>
				<Button className="oidc-session-lost__button" onClick={() => window.location.reload()}>
					Re-authenticate
				</Button>
			</div>
		</div>
	);
};

export { SessionLost };
